import {doc} from '../../docs.js';


doc(
    'sdf.translate',
    {
        'sdf list': '',
        x:'',
        y:'',
    },
    'Translate group of sdfs',
    () => 1,
    {
        isHot: true,
        inlets: 3
    });

const sdf_translate = (object, x, y) => {
    return ([group]) => {
        if (!Array.isArray(group)) {
            return undefined;
        }
        if (x() === undefined || y() === undefined) {
            return [group];
        }
        let _group = group.map(
            sdf => {
                if (!Array.isArray(sdf)) {
                    return undefined;
                }
                let _sdf = [... sdf];
                _sdf[1] += x();
                _sdf[2] += y();
                return _sdf;
                
            })
            .filter(group => group);
        
        return [_group];
    };
};

doc(
    'sdf.scale',
    {
        'sdf list': '',
        scale:'',
    },
    'Translate group of sdfs',
    () => 1,
    {
        isHot: true,
        inlets: 2
    });

const sdf_scale = (object, scale) => {
    return ([group]) => {
        if (!Array.isArray(group)) {
            return undefined;
        }
        if (scale() === undefined) {
            return [group];
        }
        let _group = group.map(
            sdf => {
                if (!Array.isArray(sdf)) {
                    return undefined;
                }
                let _sdf = [... sdf];
                _sdf[1] *= scale();
                _sdf[2] *= scale();
                _sdf[3] *= scale();
                _sdf[4] *= scale();
                _sdf[5] *= scale();
                return _sdf;
            })
            .filter(g => g);

        return [_group];
    };
};
export const sdf_groups = {
    'sdf.translate': sdf_translate,
    'sdf.scale': sdf_scale
};
